module.exports = __webpack_public_path__ + "static/img/fun_corner_icon.1209b4b8.png";